var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPageChecklistBlue = function SvgIconPageChecklistBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.5h-15a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-15a1 1 0 0 0-1-1Z",
    fill: "#748FFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.5h15a1 1 0 0 1 1 1v2h-17v-2a1 1 0 0 1 1-1Z",
    fill: "#4C6EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.501 10.418a1.146 1.146 0 1 0 0-2.293 1.146 1.146 0 0 0 0 2.293ZM10.14 12.875H6.86a.496.496 0 0 1-.482-.627c.267-.92 1.117-1.535 2.123-1.535 1.007 0 1.855.616 2.124 1.535a.496.496 0 0 1-.482.627h-.003ZM15.983 12.13l1.722-1.982a.688.688 0 0 0-1.037-.902l-1.723 1.981a.687.687 0 0 0 1.038.902Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.95 11.192-1.15-1.15a.688.688 0 0 0-.972.973l1.15 1.149a.688.688 0 0 0 .972-.972Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.313 16.078h-3.125a.687.687 0 1 0 0 1.375h3.124a.687.687 0 1 0 0-1.375ZM8.501 16.496a1.146 1.146 0 1 0 0-2.292 1.146 1.146 0 0 0 0 2.292ZM10.14 18.953H6.86a.496.496 0 0 1-.482-.628c.267-.919 1.117-1.535 2.123-1.535 1.007 0 1.855.616 2.124 1.535a.496.496 0 0 1-.482.628h-.003Z",
    fill: "#BAC8FF"
  })));
};
export default SvgIconPageChecklistBlue;